import type { RawTab } from '../../types';

import * as shared from './shared';

export const EarnTab: RawTab = {
  id: shared.id,

  link: shared.link,

  iconSource: require('./icons/fhs-earn-inactive.png'),
  iconActiveSource: require('./icons/fhs-earn-active.png'),

  text: {
    en: 'Earn',
    // @TODO: french text
    fr: 'Earn',
  },
};
